export const Duration = {
  fast: '150ms',
  normal: '200ms',
  slow: '350ms',
} as const;

export type DurationTokenType = keyof typeof Duration;

export const Easing = {
  linear: 'linear',
  easeInOut: 'ease-in-out',
  ease: 'ease',
} as const;

export type EasingTokenType = keyof typeof Easing;
